<script>
  import { onMount } from 'svelte'
  import Header from './header/header.svelte'
  import Nav from './nav/nav.svelte'
  import Footer from './footer/footer.svelte'
  import Fargetema from './fargetema/fargetema.svelte'
  import { currentRouteComponent, currentRoute } from '@/stores/router'
  import { cols } from '@/stores/cols'
  import { title } from '../stores/title'
  import { history } from './router/navigation'

  onMount(() => {
    const unlisten = history.listen(({ action, location }) => {
      // handle browser back/forward
      if (action === 'POP') {
        if (location.state) {
          currentRoute.set(location.state)
        } else {
          currentRoute.set({ name: 'landing', params: {} })
        }
      }
    })

    return () => unlisten()
  })

  function updateCols() {
    cols.set(window.innerWidth >= 700 ? 4 : 2)
  }
  onMount(updateCols)
</script>

<style>
  .content {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 6px;
  }
  main {
    min-height: 50vh;
  }

  :global(:root) {
    --appelsinsorbet: #ffb27b;
    --pistasj: #6ba292;
    --friskis: #fee5ce;
    --kraesjpink: #bfb8da;
    --blaafruktfest: #8392de;
    --vannmelon: #f888a3;
    --mint: #6c966b;
    --lakris: #8a73ca;
    --tuttifrutti: #ff9567;
    --bringebaersorbet: #ffacac;
    --lavendel: #70e3ba;
  }
</style>

<svelte:head>
  <title>{$title}</title>
</svelte:head>

<svelte:window on:resize={updateCols} />

<Fargetema>
  <Header />
  <Nav />
  <div class="content">
    <main>
      <svelte:component this={$currentRouteComponent} {...$currentRoute.params} />
    </main>
  </div>
  <Footer />
</Fargetema>
